import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../lib/adminApi';
import { toast } from 'sonner';

// Fully separate login screen from the regular Orbit passwordless flow.
// Plain username/password against the backend's own admin credential
// store (bcrypt hash, not Supabase Auth) -- deliberately not styled to
// look like the regular app, so it's obviously a different surface.
export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await adminLogin(username, password);
      nav('/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center" style={{ background: '#0d0d12' }}>
      <form onSubmit={submit} className="w-full max-w-sm p-8 rounded-2xl" style={{ background: '#17181f', border: '1px solid #2a2b35' }}>
        <h1 className="text-xl font-bold mb-1" style={{ color: '#e5e5ea' }}>Orbit Admin</h1>
        <p className="text-sm mb-6" style={{ color: '#8a8a94' }}>Restricted access. Backend-managed credentials only.</p>

        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          autoComplete="username"
          className="w-full mb-4 px-4 h-12 rounded-xl outline-none"
          style={{ background: '#0d0d12', color: '#e5e5ea', border: '1px solid #2a2b35' }}
        />
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          className="w-full mb-4 px-4 h-12 rounded-xl outline-none"
          style={{ background: '#0d0d12', color: '#e5e5ea', border: '1px solid #2a2b35' }}
        />

        {error && <p className="text-sm mb-3" style={{ color: '#ff6b6b' }}>{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="press w-full h-12 rounded-xl font-semibold"
          style={{ background: '#3b3f51', color: '#fff', opacity: loading ? 0.6 : 1 }}
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
